import React from 'react';
import { Alert, Modal, ModalProps } from 'react-bootstrap';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Representative } from '../../types';
import { ControlledAlertModal } from '../../../common/ControlledModal';
import { generateNewContractSigningLink } from '../backofficeServices';

interface GenerateNewLinkConfirmationProps extends ModalProps {
  data: Representative;
}

export function GenerateNewLinkConfirmationModal(
  { show, onHide, data }: GenerateNewLinkConfirmationProps,
) {
  if (!data) return null;
  const description = `¿Está seguro/a de que desea generar y enviar un nuevo link de firma a ${data.representative_email}?`;
  const queryClient = useQueryClient();
  const { mutate, isLoading, isError } = useMutation({
    mutationFn: () => generateNewContractSigningLink({ representativeId: data.id }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['signing-processes'] });
      onHide?.();
    },
  });
  return (
    <ControlledAlertModal
      show={show}
      onHide={onHide}
      title="Generar y enviar nuevo link de firma"
      description={description}
      closeButton
      centered
    >
      {isError && (
        <Alert variant="danger" title="Error">
          Algo salió mal al generar y enviar un nuevo link de firma. Por favor, intenta nuevamente.
        </Alert>
      )}
      <Modal.Footer className="d-flex  align-items-end gap-2">
        <ControlledAlertModal.Actions
          handleClose={onHide || (() => {})}
          onConfirm={() => mutate()}
          isPending={isLoading}
        />
      </Modal.Footer>
    </ControlledAlertModal>
  );
}
